import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, inject } from '@angular/core';
import { IDynamicViewControl, IKeyValuePairAny } from '@app/core/contracts/dto';
import { ModalController, ToastController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { AddMedicalProblemComponent } from './add-medical-problem-modal/add-medical-problem.component';

@Component({
    selector: 'app-medical-problem-manager',
    templateUrl: './medical-problem-manager.component.html',
    styleUrls: ['./medical-problem-manager.component.scss'],
    standalone: false
})
export class MedicalProblemManagerComponent implements OnInit, OnDestroy {
  modalController = inject(ModalController);
  private toastController = inject(ToastController);

  @Input() formGroupControl: IDynamicViewControl = null;
  @Input() data: IKeyValuePairAny = null;
  @Output() medicalProblemsUpdated: EventEmitter<IKeyValuePairAny> = new EventEmitter();

  errorMessage = null;
  componentDestroyed$: Subject<boolean> = new Subject();

  ngOnInit() {
    if (!this.formGroupControl) {
      this.errorMessage = 'Key not specified.';
      return;
    }

    if (!this.data || !this.data.value) {
      this.data = { key: this.formGroupControl.key, value: [] };
    }
  }

  async openMedicalProblemAdditionModal() {
    const modal = await this.modalController.create({
      component: AddMedicalProblemComponent,
      cssClass: 'modal-100'
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      if (!this.data || !this.data.value) {
        this.data = { key: this.formGroupControl.key, value: [] };
      }

      // check if exists
      if (this.data.value.find((m) => m.name.toLowerCase().replace(' ', '') === data.name.toLowerCase().replace(' ', ''))) {
        this.presentToast(`${data.name} has already been added.`);
      } else {
        this.data.value.push(data);
      }
    }
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }

  removeMedicalProblem(item) {
    const itemIndex = this.data.value.findIndex((m) => m.name.toLowerCase().replace(' ', '') === item.name.toLowerCase().replace(' ', ''));
    if (itemIndex > -1) {
      this.data.value.splice(itemIndex, 1);
    }
  }

  ngOnDestroy() {
    this.medicalProblemsUpdated.emit(this.data);
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
